import React from 'react';
import Services from '../../../pages/Services';
import CustomDesign from '../../../pages/CustomDesign';
import AIPhoneAssistantPage from '../../../pages/AIPhoneAssistantPage';
import BusinessPhone from '../../../pages/BusinessPhone';
import ClientPortals from '../../../pages/ClientPortals';
import WebApps from '../../../pages/WebApps';
import Rewards from '../../../pages/Rewards';
import SquareIntegrations from '../../../pages/SquareIntegrations';

export const servicesRoutes = [
  { path: '/services', element: <Services /> },
  { path: '/services/custom-design', element: <CustomDesign /> },
  { path: '/services/ai-phone-assistant', element: <AIPhoneAssistantPage /> },
  { path: '/services/business-phone', element: <BusinessPhone /> },
  { path: '/services/client-portals', element: <ClientPortals /> },
  { path: '/services/web-apps', element: <WebApps /> },
  { path: '/services/rewards', element: <Rewards /> },
  { path: '/services/square-integrations', element: <SquareIntegrations /> }
];
